import React, { Component } from 'react';
import { InfoButton } from "../DesignFunctions"

class PootsySelectInput extends Component {

	constructor(props) {
		super(props)

		this.state = {
			selectedValue: this.props.selectedValue ? this.props.selectedValue : (this.props.defaultValue !== undefined) ? this.props.defaultValue : this.props.options[0].value,
			isOptionsVisible: false
		}
	}

	componentWillMount() {
		document.addEventListener('click', this.handleClickOutside)
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			selectedValue: nextProps.selectedValue ? nextProps.selectedValue : (nextProps.defaultValue !== undefined) ? nextProps.defaultValue : nextProps.options[0].value,
		})
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside)
	}

	render() {
		let { disableSelection } = this.props
		return (
			<div className={"PootsySelectInput" + (disableSelection ? " disabled" : "")} ref="wrapper">
				{this.renderLabel()}
				<div className="select" onClick={this.onSelectClick}>
					{this.renderSelectedOption()}
					<div className={"arrow" + (this.state.isOptionsVisible ? " opened" : "")}/>
				</div>
				<div className={"options" + (this.state.isOptionsVisible ? "" : " gone")}>
					{
						this.props.options.map(option =>
							<div className={"option" + (option.value === this.state.selectedValue ? " selected" : "")}
								 key={option.value}
								 onClick={() => this.onOptionSelected(option)}>{option.label}</div>
						)
					}
				</div>
			</div>
		)
	}

	renderLabel = () => {
		if (this.props.label) {
			return (
				<div className="label">{this.props.label} {this.renderInfoButton()}</div>
			)
		}
	}

	renderInfoButton = () => {
		if (this.props.infoText) {
			return (
				<InfoButton text={this.props.infoText}/>
			)
		}

		return null
	}

	renderSelectedOption = () => {
		let label
		if (this.state.selectedValue !== undefined) {
			this.props.options.forEach((option) => {
				if (option.value === this.state.selectedValue) {
					label = option.label
				}
			})

			if (label === undefined && this.props.defaultValue !== undefined) {
				label = this.props.defaultValue
			}
			else if (label === undefined) {
				label = this.props.options[0].label
			}
		} else {
			label = this.props.options[0].label
		}

		return (
			<div className="label">{label}</div>
		)
	}

	onSelectClick = () => {
		let { disableSelection } = this.props
		if(!disableSelection){
			this.setState({ isOptionsVisible: !this.state.isOptionsVisible })
		}
	}

	onOptionSelected = (option) => {
		this.setState({ selectedValue: option.value, isOptionsVisible: false })

		if (this.props.onChange) {
			this.props.onChange(option)
		}
	}

	handleClickOutside = e => {
		e.stopPropagation()
		let wrapper = this.refs.wrapper
		let isClickInside = wrapper.contains(e.target);
		if (!isClickInside) {
			this.setState({ isOptionsVisible: false })
		}
	}
}

export default PootsySelectInput;

PootsySelectInput.defaultProps = {
	disableSelection: false
}


// WEBPACK FOOTER //
// ./src/components/shared/PootsySelectInput.js